import { inject, Injectable } from '@angular/core';
import { ProfileCacheService } from './profile-cache.service';
import { UserFacade } from '@lentau/profile/store/user/user.facade';
import { ProfileCacheUpdateService } from './profile-cache-update.service';
import { UserProfile } from 'angular-api-gateway/v1/model/userProfile';
import { AuthFacade } from '@lentau/auth/store';
import { PlatformService } from '@lentau/ui-kit/core/services/platform/platform.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileCacheFacade {
  private profileCacheService: ProfileCacheService = inject(ProfileCacheService);
  private userFacade: UserFacade = inject(UserFacade);
  private profileCacheUpdateService: ProfileCacheUpdateService = inject(ProfileCacheUpdateService);
  private authFacade: AuthFacade = inject(AuthFacade);
  private platformService: PlatformService = inject(PlatformService);

  public init(): void {
    this.getCachedState();
    this.profileCacheUpdateService.updateProfileIds();
  }

  public getCachedState(): void {
    const userProfile: Partial<UserProfile> = this.profileCacheService.getProfileIds();

    if (userProfile) {
      this.userFacade.setProfileCache(userProfile);
      this.authFacade.setIsAuthByCache();
    }
  }

  public clear(): void {
    this.profileCacheService.deleteCache();
  }
}
